import React, {Component} from "react";
import styles from "./RightPicture.module.scss";

class RightPicture extends Component {

    render() {
        const { smalltitle, title, description, picture, alt } = this.props;
        return (
		<section className={styles.rightPicture}>
			<div className="container">
				<div className="row row-bottom-padded-lg row-top-padded-lg right-picture">
					<div className="col-md-6">
						<div className={`${styles.fh5colabel} animate-box`}>{smalltitle}</div>
						<h2 className={`${styles.fh5colead} animate-box`}>{title}</h2>
						<p className={`${styles.fh5cosublead} animate-box`}>{description}</p>
					</div>
                    <div className="col-md-6 d-flex">
						<figure className="animate-box  align-self-stretch d-flex text-center">
							<img src={picture} alt={alt} className="img-fluid align-self-center" />
						</figure>
					</div>
				</div>
			</div>
		</section>
        );
    }
}

export default RightPicture;



// WEBPACK FOOTER //
// ./src/components/Section/RightPicture.jsx